import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../../hoc/clientOnly';

const Carousel = lazy(() =>
  import(/* webpackChunkName: "Carousel" */ './Carousel')
);

const Loader = props => (
  <Suspense fallback={null}>
    <Carousel {...props} />
  </Suspense>
);

export default clientOnly(Loader);
